import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { toolbarCurrentOptions } from './toolbar';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { classList } from '@/helpers';
import { FieldError } from 'react-hook-form';
import './styles.scss';

interface IWYSIWYGEditorProps {
  value: string | undefined;
  required?: boolean;
  errors?: string | string[];
  error?: FieldError;
  onChange: (value: string) => void;
  toolbarOptions?: any | undefined;
}

const WYSIWYGEditor = (props: IWYSIWYGEditorProps): React.ReactElement => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const { value, onChange, toolbarOptions } = props;

  const onEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);
    return onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  useEffect(() => {
    if (value) {
      const blocksFromHtml = htmlToDraft(value);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [value]);

  return (
    <EditorContainer className={classList(props.error && 'error')}>
      <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onEditorStateChange={onEditorStateChange}
        toolbar={toolbarOptions ?? toolbarCurrentOptions}
      />
    </EditorContainer>
  );
};

export { WYSIWYGEditor };

const EditorContainer = styled.div`
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  padding: 2px;
  background-color: #f9fafb;

  > * {
    color: #343a40;
  }

  &.error {
    border: 1px solid #dc3545 !important;
  }

  &:read-only {
    color: #868e96;
  }
`;
